import {useEffect, useState} from 'react'

const useDidUpdate = (callback, conditions) => {
  const [hasMounted, setHasMounted] = useState(false)
  if (typeof conditions !== 'undefined' && !Array.isArray(conditions)) {
    conditions = [conditions]
  } else if (Array.isArray(conditions) && conditions.length === 0) {
    console.warn(
      'Using [] as the second argument makes useDidUpdate a noop. The second argument should either be `undefined` or an array of length greater than 0.'
    )
  }
  useEffect(() => {
    setHasMounted(true)
  }, [])
  useEffect(() => {
    if (hasMounted) {
      callback()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, conditions)
}

export default useDidUpdate
